<template>
  <div class="UserDashboard">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="sideBarSection">
      <UserDashboardSideBar
        :active_sub_menu="active_subMenu_link"
        :filterList="filter_list"
        :resetFilters="reset_filter"
        :active_period="active_period"
        v-if="isDesktop"
      ></UserDashboardSideBar>
    </div>

    <div class="reco-details-container">
      <div class="sub-menu-section">
        <div class="sub-menu-bar-wrapper">
          <div class="sub-menu-bar">
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_STOCKS')"
              :class="{
                'active-sub-menu-link': active_subMenu_link == 'TOP_STOCKS',
              }"
            >
              Top Stocks
            </div>

            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_SECTORS')"
              :class="{
                'active-sub-menu-link': active_subMenu_link == 'TOP_SECTORS',
              }"
            >
              Top Sectors
            </div>
          </div>
          <div style="margin: 0 15px">
            <!-- v-if="
              activeSubMenuLink == 'EXPERTS_HUB' ||
                activeSubMenuLink == 'TOP_EXPERTS'
            " -->
            <div class="flex">
              <div
                class="period-btn-mini"
                @click="selectPeriod('1M')"
                :class="[active_period == '1M' ? 'active-period-btn-mini' : '']"
              >
                1M
              </div>

              <div
                class="period-btn-mini"
                @click="selectPeriod('3M')"
                :class="[active_period == '3M' ? 'active-period-btn-mini' : '']"
              >
                3M
              </div>
              <div
                class="period-btn-mini"
                @click="selectPeriod('6M')"
                :class="[active_period == '6M' ? 'active-period-btn-mini' : '']"
              >
                6M
              </div>
              <div
                class="period-btn-mini"
                @click="selectPeriod('1Y')"
                :class="[active_period == '1Y' ? 'active-period-btn-mini' : '']"
              >
                1Y
              </div>
              <!-- <div
                class="period-btn-mini"
                @click="selectPeriod('MAX')"
                :class="[
                  active_period == 'MAX' ? 'active-period-btn-mini' : '',
                ]"
              >
                MAX
              </div> -->
            </div>
          </div>
          <!-- <div class="flex-last-child">
            <div class="download-btn">
              STOCKANTS 360 REPORT
            </div>
          </div> -->
        </div>
      </div>

      <div class="reco-details-section">
        <div v-if="active_subMenu_link == 'TOP_STOCKS'">
          <UserDashboardTopStocks
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          ></UserDashboardTopStocks>
        </div>

        <div v-if="active_subMenu_link == 'TOP_SECTORS'">
          <UserDashboardTopSectors
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          ></UserDashboardTopSectors>
        </div>

        <!-- <div class="text-center" v-if="is_expert_list_loading">
          <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px;" />
        </div> -->
        <MobileDashboardFilterDialog
          v-if="!isDesktop"
          :active_sub_menu="active_subMenu_link"
          :filterList="filter_list"
          :resetFilters="reset_filter"
          class="nav-filter-icon"
        ></MobileDashboardFilterDialog>
      </div>
    </div>
  </div>
</template>
<script>
import { serverHostName } from "../networkConfig";
import { screenSize } from "../mixins/ScreenSize.js";
import UserDashboardSideBar from "@/components/UserDashboardSideBar.vue";
import UserDashboardTopStocks from "@/components/UserDashboardTopStocks.vue";
import UserDashboardTopSectors from "@/components/UserDashboardTopSectors.vue";
import MobileNav from "@/components/MobileNav.vue";
import { EventBus } from "../eventBus";
import MobileDashboardFilterDialog from "@/components/MobileDashboardFilterDialog.vue";

export default {
  name: "UserDashboard",
  components: {
    UserDashboardSideBar,
    UserDashboardTopStocks,
    UserDashboardTopSectors,
    MobileNav,
    MobileDashboardFilterDialog,
  },
  mixins: [screenSize],

  data() {
    return {
      nav_title: "Home",
      profile_pic: require("../assets/images/navBar/avatar.jpg"),
      active_subMenu_link: "TOP_STOCKS",
      filter_list: "",
      reset_filter: false,
      active_period: "1M",
    };
  },

  mounted() {
    if (this.userProfile.picture) {
      this.profile_pic = serverHostName + this.userProfile.picture;
    }
  },

  methods: {
    selectPeriod(period) {
      if (period == "1M") {
        this.active_period = "1M";
      } else if (period == "3M") {
        this.active_period = "3M";
      } else if (period == "6M") {
        this.active_period = "6M";
      } else if (period == "1Y") {
        this.active_period = "1Y";
      } else if (period == "MAX") {
        this.active_period = "MAX";
      }
    },

    getFilterList(list) {
      this.filter_list = list;
    },

    //to reset all selected filters after changing sub menu or changing tables headers
    resetAllSelectedFilters() {
      this.reset_filter = !this.reset_filter;
    },

    //set active sub menu links e.g. last reco, accuracy achieved
    setActiveSubMenuLink(label) {
      if (label == "TOP_STOCKS") {
        this.active_subMenu_link = label;
      } else if (label == "TOP_SECTORS") {
        this.active_subMenu_link = label;
      }

      this.active_period = "1M";
      
      this.resetAllSelectedFilters();

      // on menu select scroll page to top
      var elmnt = document.getElementsByClassName("UserDashboard")[0];
      scrollTo(elmnt, 0, 100);

      // EventBus.$emit('emitActiveMenu', label);  //emitted event in homepage sidebar page
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
};
</script>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.UserDashboard {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 60px 0;
}
.UserDashboard .reco-details-container {
  width: calc(100% - 265px);
  margin-left: 265px;
  min-height: 100vh;
}
.UserDashboard .actionBtn-section {
  display: flex;
}
.UserDashboard .reco-details-section {
  padding: 65px 10px 0 10px;
}
.UserDashboard .sub-menu-bar-wrapper {
  background: $page-background-color;
  width: 80%;
}
.UserDashboard .footer-section {
  width: calc(100% - 260px);
  margin-left: 260px;
}
.no-data-labels {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
}
.axis-description {
  color: #333;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}
.share_btn {
  background-image: linear-gradient(to left, #dc6250, #eb5151);
  width: 220px;
  color: #fff;
  font-size: 14px;
  border: none;
  cursor: pointer;
}
.share_btn:hover {
  color: #fff;
  transition: 0.4s ease;
  box-shadow: 0px 0px 10px -1px #dc6250;
}
@media screen and (max-width: 1283px) {
  .UserDashboard {
    padding: 50px 0 80px 0;
  }

  .UserDashboard .sub-menu-bar-wrapper {
    width: 100%;
  }

  .UserDashboard .sub-menu-bar {
    width: 100%;
  }
  .UserDashboard .actionBtn-section {
    justify-content: center;
    padding: 10px;
  }
  .UserDashboard .search-stock-wrapper {
    display: flex;
    justify-content: center;
  }
  .UserDashboard .search-stock-container {
    width: 300px;
    margin-right: 0px;
  }
  // .UserDashboard .sub-menu-section {
  //   width: 100%;
  //   padding: 0;
  // }
  .UserDashboard .reco-details-container,
  .UserDashboard .footer-section {
    width: 100%;
    margin-left: 0;
  }
  .UserDashboard .reco-details-section {
    padding: 60px 10px 0 10px;
  }
  .UserDashboard .search-stock-wrapper {
    margin: 5px 0;
  }
  .UserDashboard .sideBarSection {
    display: none;
  }
}
</style>
